
  import {Component, Vue} from "vue-property-decorator";
  import MyList from "@/components/myList.vue";
  import {getConfig, saveLangdingPage} from '@/services/api'
  import store from "@/store";
  import validator from "@/services/validatorNew";


  @Component({
    components: {'my-list': MyList},
  })
  export default class StationAdd extends Vue{

    // 域名列表
    public domainList: {domain: string, pixel: string, path: string}[] = []
    // 域名列表
    public filterDomainList: {domain: string, pixel: string, path: string}[] = []
    // 搜索query
    public searchQuery = '';
    // 模版列表
    public templateList: {templateId: number, templateName: string}[] = [{
      "templateId": 0,
      "templateName": "通用模版"
    }]

    // 表单信息
    public formData: {
      domain?: string,
      pixel?: string,
      pixelGG?: string,
      path?: string,
      templateId?: number,
      templateName?: string,
      itemIds: any[],
      [props: string]: any
    } = {
      domain: "",
      pixel: "",
      path: "",
      templateId: 0,
      templateName: "",
      itemIds: []
    }

    // 验证规则
    private rules: {[key: string]:{required: boolean, requiredMsg?: string, reg?: RegExp, regMsg?: string, max?: number, maxMsg?: string, min?: number, minMsg?: string}}= {
      domain: {required: true, requiredMsg: '投放域名不能为空'},
      templateId: {required: true, requiredMsg: '投放模版不能为空'},
      itemIds: {required: true, requiredMsg: '关联产品不能为空'},
    }

    // 选择框展示
    public dialogVisible = false;

    /**
     * 初始化方法
     */
    created() {
      this.getConfig();
    }

    /**
     * 获取字典信息
     */
    getConfig(): void {
      if (!this.$store.state.domain || this.$store.state.domain.length === 0) {
        getConfig({type: 'domain'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.domainList = res.data.result || [];
            store.commit('SET_DOMAIN', this.domainList);
          }
        })
      } else {
        this.domainList = this.$store.state.domain;
      }
    }

    clearQuery() {
      this.searchQuery = '';
      this.filterDomainList = [];
    }

    filterDomains(queryString: string) {
      if (queryString !== '') {
        console.log(queryString);
        // 模拟异步搜索，根据实际情况替换为真实的搜索逻辑
        this.filterDomainList = this.domainList.filter(item => {
          return item.domain.includes(queryString);
        });
      } else {
        // 如果没有搜索关键词，则不显示选项
        this.filterDomainList = [];
      }
    }

    /**
     * 上传
     */
    submit() {
      if(!this.checkForm()) {
        return;
      }
      for (let domain of this.domainList) {
        if (this.formData.domain === domain.domain) {
          this.formData.path = domain.path;
          // this.formData.pixel = domain.pixel;
        }
      }
      for (let template of this.templateList) {
        if (this.formData.templateId === template.templateId) {
          this.formData.templateName = template.templateName;
        }
      }
      saveLangdingPage(this.formData, true).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.$message.success('保存成功')
          this.$router.push('/station/list');
        } else {
          this.$message.error(res.data.body.message);
        }
      }).catch(() => {})
    }

    /**
     * 校验表单内容是否通过
     */
    checkForm(): boolean {
      for (let key of Object.keys(this.rules)) {
        if(!validator(this.rules[key], this.formData[key], (msg: string) => {
          this.$message.error(msg);
        })) {
          return false;
        }
      }
      if(!this.formData.pixel && !this.formData.pixelGG && !this.formData.pixelSC) {
        this.$message.error('至少需要设置一个像素');
        return false;
      } else if (this.formData.pixel && !/^[0-9a-zA-Z]*$/.test(this.formData.pixel)) {
        this.$message.error('fb/tiktok像素格式不正确');
        return false;
      } else if (this.formData.pixelGG && !/^(UA-[0-9]+(-[0-9]+)?|AW-[0-9]+|G-[0-9a-zA-Z]+)$/.test(this.formData.pixelGG)) {
        this.$message.error('谷歌像素格式不正确');
        return false;
      } else if (this.formData.pixelSC && !/^([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[a-zA-Z0-9]{32,40})$/i.test(this.formData.pixelSC)) {
        this.$message.error('Snapchat像素格式不正确');
        return false;
      }
      return true;
    }

    /**
     * 关闭选择框
     */
    handleClose(): void {
      this.dialogVisible = false;
    }

    /**
     * 删除关联产品
     * @param itemIds
     * @param index
     */
    deleteItem(itemIds: any[], index: number): void {
      itemIds.splice(index, 1);
    }

    /**
     * 添加关联产品
     * @param selectedList
     */
    addItem(selectedList: any[]) {
      this.formData.itemIds.push(...selectedList.map(item => item.itemId));
      this.dialogVisible = false;
    }
  }
